const { render, useEffect, useState, useRef } = wp.element;

import Map from './components/Map';

const setupDealers = dealers => {
	if ( dealers.length === 0 ) {
		return {};
	}

	const response = dealers.map( dealer => {
		const { id, acf, title, link } = dealer;
		const { dealer_address: address, dealer_email: email, dealer_phone: phone, dealer_website: website, dealer_subheading: subheading, dealer_extrafield1: extrafield1, dealer_extrafield2: extrafield2 } = acf;
		const { lat, lng } = address;
		return { id, address, lat, lng, content: { title: title.rendered, email, phone, website, link, subheading, extrafield1, extrafield2 } };
	} );

	return response;
};
const data = {
	per_page: 200,
};

const App = () => {
	const [ dealers, setDealers ] = useState( [] );
	const [ isDealersLoaded, setIsDealersLoaded ] = useState( false );

	const dealersFetch = useRef();

	useEffect( () => {
		async function fetchDealers() {
			// https://developer.wordpress.org/rest-api/using-the-rest-api/backbone-javascript-client/#collection-examples
			const dealersCollection = new wp.api.collections.Dealer();

			// Fetch first page
			await dealersCollection.fetch( { data } ).then( response => {
				setDealers( setupDealers( response ) );
				dealersFetch.current = dealersCollection;
				data.page = 2;
			} );

			// Return and show map if that's all there is.
			if ( ! dealersFetch.current.hasMore() ) {
				setIsDealersLoaded( true );
				return;
			}

			// Fetch the rest.
			while ( dealersFetch.current.hasMore() ) {
				await dealersFetch.current.more( { data } ).then( response => {
					setDealers( state => state.concat( setupDealers( response ) ) );
					data.page++;
				} );

				dealersFetch.current = dealersFetch.current;
			}

			// We are done here!
			setIsDealersLoaded( true );
		}
		// Fix from https://github.com/WP-API/client-js/issues/106
		wp.api.loadPromise.done( function() {
			fetchDealers();
		} );
	}, [] );

	if ( ! isDealersLoaded ) {
		return 'Loading retailers...';
	}

	return (
		<Map dealers={ dealers } />
	);
};

const element = document.getElementById( 'dealer-app' );

if ( element ) {
	render( <App />, document.getElementById( 'dealer-app' ) );
}
